import { redirect, useNavigate } from "@tanstack/react-router";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { toast } from "sonner";
import { Button } from "~/components/ui/button";
import { Input } from "~/components/ui/input";
import { Label } from "~/components/ui/label";
import { authClient } from "~/lib/auth-client";
import { getAuthSession } from "~/lib/server/functions/auth";
import { gainBetaAccess } from "~/lib/server/functions/beta";
import { m } from "~/i18n/messages";

export const Route = createFileRoute("/maintenance")({
	component: MaintenancePage,
	beforeLoad: async () => {
		const { isAuthenticated, user } = await getAuthSession();
		if (!isAuthenticated) throw redirect({ to: "/" });
		if (user.role !== "user") throw redirect({ to: "/app" });
	},
});

function MaintenancePage() {
	const navigate = useNavigate();
	const [code, setCode] = useState("");

	async function handleSignOut() {
		await authClient.signOut({
			fetchOptions: {
				onSuccess: () => navigate({ to: "/" }),
			},
		});
	}

	async function handleSubmit() {
		if (!code) return toast.error(m["maintenance.empty_code_error"]());
		toast.promise(gainBetaAccess({ data: { code } }), {
			loading: m["maintenance.checking_code_status"](),
			success: (data) => {
				if (data.success) {
					setTimeout(() => window.location.reload(), 1000);
					return {
						message: m["maintenance.beta_success_title"](),
						description: m["maintenance.beta_success_message"](),
					};
				}
				return {
					type: "error",
					message: m["maintenance.incorrect_code_title"](),
					description: m["maintenance.incorrect_code_message"](),
				};
			},
			error: m["maintenance.generic_error"](),
		});
	}

	return (
		<div className="flex flex-col items-center justify-center h-full w-full bg-gradient-to-t from-pink-50 to-white p-4">
			<h1 className="text-2xl md:text-4xl font-medium text-pink-800 mb-2 text-center">
				{m["maintenance.page_title"]()}
			</h1>
			<p className="text-pink-500/75 saturate-50 text-sm md:text-lg mb-8 text-center">
				{m["maintenance.wait_message"]()}
			</p>
			<img
				src="https://raw.githubusercontent.com/elianiva/elianiva/refs/heads/master/bocchi-mumumu.gif"
				alt="bocchi lol"
				className="w-full max-w-sm rounded-xl shadow-lg mb-4"
			/>
			<Button variant="link" className="underline" onClick={handleSignOut}>
				{m["maintenance.sign_out_link"]()}
			</Button>
			<div className="pt-10 flex flex-col gap-2 items-center">
				<Label className="flex-col items-start max-w-sm text-center">
					{m["maintenance.secret_code_prompt"]()}
					{m["maintenance.beta_access_prompt"]()}
					<Input
						className="bg-white"
						placeholder={m["maintenance.secret_code_placeholder"]()}
						value={code}
						onChange={(e) => setCode(e.target.value)}
					/>
				</Label>
				<Button onClick={handleSubmit}>Submit</Button>
			</div>
		</div>
	);
}
